import { render, staticRenderFns } from "./MyMedicineList.vue?vue&type=template&id=1a5fcaab&scoped=true&"
import script from "./MyMedicineList.vue?vue&type=script&lang=js&"
export * from "./MyMedicineList.vue?vue&type=script&lang=js&"
import style0 from "./MyMedicineList.vue?vue&type=style&index=0&id=1a5fcaab&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a5fcaab",
  null
  
)

export default component.exports